// extracted by mini-css-extract-plugin
export default {"success_container":"style_success_container__bAlpv","texts":"style_texts__4qjEW","texts_top":"style_texts_top__QuYFW","texts_ok":"style_texts_ok__JvKii"};